import React, { useState, useEffect } from 'react';
import { Autocomplete, TextField, Button, CircularProgress, Box, Grid2, Typography } from '@mui/material';
import config from '../../common/Config';
// import Swal from 'sweetalert2';
import {toast} from 'sonner';

const ChannelBrandList = ({ refresh }) => {
  const accessToken = localStorage.getItem('accessToken');
  const [selectedChannelBand1, setSelectedChannelBand1] = useState(null);
  const [selectedChannelBand2, setSelectedChannelBand2] = useState(null);
  const [selectedChannelBand3, setSelectedChannelBand3] = useState(null);
  const [selectedChannelBand4, setSelectedChannelBand4] = useState(null);
  const [selectedChannelBand5, setSelectedChannelBand5] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);

  // Static band options
  const bandOptions = [
    { label: "Band 1", value: "1" },
    { label: "Band 2", value: "2" },
    { label: "Band 3", value: "3" },
    { label: "Band 4", value: "4" },
    { label: "Band 5", value: "5" },
    { label: "Band 6", value: "6" },
  ];

  // Fetch current band assignments from API
  useEffect(() => {
    const fetchBandList = async () => {
      if (!accessToken) return;
      
      setLoading(true);
      try {
        const response = await fetch(`${config.API_URL}/get_band_list`, {
          method: 'POST',
          headers: {
            authorization: `Bearer ${accessToken}`,
          }
        });
        
        const data = await response.json();
        
        if (data.success && data.data && Array.isArray(data.data)) {
          console.log('Fetched band list data:', data.data);
          
          // Map channel bands to state
          data.data.forEach((channelBand) => {
            const bandId = channelBand.band_id?.toString();
            // Convert channel_id to number for comparison
            const channelId = parseInt(channelBand.channel_id, 10);
            
            console.log(`Processing channel_id: ${channelId}, band_id: ${bandId}`);
            
            // Find the band option
            const bandOption = bandOptions.find(opt => opt.value === bandId);
            
            console.log(`Found band option:`, bandOption);
            
            // Set the selected band based on channel_id
            switch (channelId) {
              case 1:
                if (bandOption) {
                  console.log('Setting channel 1 to:', bandOption);
                  setSelectedChannelBand1(bandOption);
                }
                break;
              case 2:
                if (bandOption) {
                  console.log('Setting channel 2 to:', bandOption);
                  setSelectedChannelBand2(bandOption);
                }
                break;
              case 3:
                if (bandOption) {
                  console.log('Setting channel 3 to:', bandOption);
                  setSelectedChannelBand3(bandOption);
                }
                break;
              case 4:
                if (bandOption) {
                  console.log('Setting channel 4 to:', bandOption);
                  setSelectedChannelBand4(bandOption);
                }
                break;
              case 5:
                if (bandOption) {
                  console.log('Setting channel 5 to:', bandOption);
                  setSelectedChannelBand5(bandOption);
                }
                break;
              default:
                console.log(`Unknown channel_id: ${channelId}`);
                break;
            }
          });
        }
      } catch (error) {
        console.error('Error fetching band list:', error);
        // Don't show error alert on initial load, just log it
      } finally {
        setLoading(false);
      }
    };

    fetchBandList();
  }, [accessToken, refresh]);

  // Handle submit
  const handleSubmit = async () => {
    setSubmitting(true);
    
    try {
      const formData = new FormData();
      
      // Map channels to their IDs (you may need to adjust these based on your channel IDs)
      const channelBands = [
        { channel_id: 1, channel_name: 'Mobile Application (Customer)', band_id: selectedChannelBand1?.value || '' },
        { channel_id: 2, channel_name: 'Website', band_id: selectedChannelBand2?.value || '' },
        { channel_id: 3, channel_name: 'Sales Representative', band_id: selectedChannelBand3?.value || '' },
        { channel_id: 4, channel_name: 'EPOS (Cash & Carry)', band_id: selectedChannelBand4?.value || '' },
        { channel_id: 5, channel_name: 'Tele Calling', band_id: selectedChannelBand5?.value || '' },
      ];
      
      formData.append('channel_bands', JSON.stringify(channelBands));
      
      const response = await fetch(`${config.API_URL}/update-channel-bands`, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData
      });
      
      const result = await response.json();
      
      if (result.success) {
        toast.success('Channel bands updated successfully!');
        // Optionally refresh the band list after successful update
        // You can trigger a refresh by calling fetchBandList again if needed
      } else {
        toast.error(result.message || 'Failed to update channel bands');
      }
    } catch (error) {
      console.error('Error submitting channel bands:', error);
      toast.error('An error occurred while updating channel bands');
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <Box sx={{ m:2 }} border="1px solid #e0e0e0" borderRadius={2} p={2} >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Grid2 container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
            <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: {sm: 1 }, textAlign: { xs: 'left', sm: 'start' } }}>
                Mobile Application (Customer)
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
              <Autocomplete

                options={bandOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedChannelBand1}
                onChange={(event, newValue) => setSelectedChannelBand1(newValue)}
                renderInput={(params) => (
                  <TextField
                    className="input-border"
                    {...params}
                    placeholder="Select Channel Band"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100%", md: "300px" } }}
                  />
                )}
              />
            </Grid2>
          </Grid2>

          <Grid2 container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
            <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: {sm: 1 }, textAlign: { xs: 'left', sm: 'start' } }}>
                Website
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
              <Autocomplete
                options={bandOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedChannelBand2}
                onChange={(event, newValue) => setSelectedChannelBand2(newValue)}
                renderInput={(params) => (
                  <TextField
                    className="input-border"
                    {...params}
                    placeholder="Select Channel Band"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100%", md: "300px" } }}
                  />
                )}
              />
            </Grid2>
          </Grid2>

          <Grid2 container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
            <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: {sm: 1 }, textAlign: { xs: 'left', sm: 'start' } }}>
                Sales Representative
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
              <Autocomplete
                options={bandOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedChannelBand3}
                onChange={(event, newValue) => setSelectedChannelBand3(newValue)}
                renderInput={(params) => (
                  <TextField
                    className="input-border"
                    {...params}
                    placeholder="Select Channel Band"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100%", md: "300px" } }}
                  />
                )}
              />
            </Grid2>
          </Grid2>

          <Grid2 container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
            <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: {sm: 1 }, textAlign: { xs: 'left', sm: 'start' } }}>
                EPOS (Cash & Carry)
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
              <Autocomplete
                options={bandOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedChannelBand4}
                onChange={(event, newValue) => setSelectedChannelBand4(newValue)}
                renderInput={(params) => (
                  <TextField
                    className="input-border"
                    {...params}
                    placeholder="Select Channel Band"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100%", md: "300px" } }}
                  />
                )}
              />
            </Grid2>
          </Grid2>

          <Grid2 container spacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mb: { xs: 2, sm: 2.5, md: 3 } }}>
            <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, mb: {sm: 1 }, textAlign: { xs: 'left', sm: 'start' } }}>
                Tele Calling
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
              <Autocomplete
                options={bandOptions}
                getOptionLabel={(option) => option.label || ""}
                value={selectedChannelBand5}
                onChange={(event, newValue) => setSelectedChannelBand5(newValue)}
                renderInput={(params) => (
                  <TextField
                    className="input-border"
                    {...params}
                    placeholder="Select Channel Band"
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100%", md: "300px" } }}
                  />
                )}
              />
            </Grid2>
          </Grid2>

          <Box sx={{ display: 'flex', justifyContent: { xs: 'center', sm: 'flex-end' }, mt: 3, px: { xs: 2, sm: 0 } }}>
            <Button
              variant="contained"
              className="button-variant-contained"
              onClick={handleSubmit}
              disabled={submitting}
              sx={{ minWidth: '120px',
               }}
            >
              {submitting ? (
                <>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  Submitting...
                </>
              ) : (
                'Submit'
              )}
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ChannelBrandList;

